// extracted by mini-css-extract-plugin
module.exports = {"lessonsTable":"LessonsTable_lessonsTable__WpfYF","top":"LessonsTable_top__2yyYr","rightSide":"LessonsTable_rightSide__9WfSk"};